(function() {
  'use strict';

  angular
    .module('service.previewContentPlayer', ['factories.serviceHelper'])
    .factory('PreviewContentPlayerService', PreviewContentPlayerService);

  PreviewContentPlayerService.$inject = ['$http', 'ServiceHelper', '$window'];

  function PreviewContentPlayerService($http, ServiceHelper, $window) {
    var url = {
      cModule: 'https://:host/:ipad/gaviota-api/trainer/cModule/:cModuleId/:action'
    };
    var keys = ['ipad', 'cModuleId', 'action'];

    var service = {
      start: start,
      nextSlide: nextSlide,
      getCompletionInfo: getCompletionInfo,
      isPreview: true
    };

    return service;

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key];
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb || angular.noop)(response);
      });
    }

    function start(params, resultCb, errorCb) {
      var action = $window.mfConfig.isIpad ? 'StartIpad' : 'StartWeb';
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: params.cModuleId,
        action: action
      });
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.get(createUrl(url.cModule, urlParams), params),
          resultCb, errorCb);
      });
    }

    function nextSlide(params, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: params.cModuleId,
        action: 'nextSlide'
      });
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.cModule, urlParams), params),
          resultCb, errorCb);
      });
    }

    function getCompletionInfo(cModuleId, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: cModuleId,
        action: 'completion'
      });
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.get(createUrl(url.cModule, urlParams)),
          resultCb, errorCb);
      });
    }
  }
})();
